import {Platform, StyleSheet, Text, Pressable, View} from 'react-native';
import FontAwesome5Pro from '../../../icons/FontAwesomeIcon';
import Styles from '../../../Styles';
import Localized from 'src/constants/AppStrings';
import Settings from 'src/Settings';
import {getDescriber} from 'src/components/elements/orderAhead/descriptor/DescriptorType';

const {recentOrderButtonStyle} = getDescriber();

const color = Platform.select({
  web: Styles.lightGray,
  default: Settings.isNewUI()
    ? recentOrderButtonStyle().recentOrderText.color
    : Styles.white,
});
type Props = {
  onPress: () => void;
  showIcon?: boolean;
};

export default function RecentOrdersButton(props: Props) {
  return (
    <Pressable
      accessible={true}
      accessibilityLabel={Localized.Buttons.recent_orders}
      accessibilityRole="button"
      accessibilityHint="Double tap to navigate to the recent orders screen"
      accessibilityState={{disabled: false}}
      aria-label={Localized.Buttons.recent_orders}
      role="button"
      onPress={props.onPress}
      style={styles.recentOrderButton}
      testID="qa_RecentOrders_btn"
      nativeID={`Recent_Order_BTN${Localized.Buttons.recent_orders}`}
    >
      {props.showIcon && (
        <FontAwesome5Pro
          aria-hidden={true}
          accessibilityElementsHidden={true}
          importantForAccessibility="no-hide-descendants"
          name="calendar-alt"
          color={color}
          size={Styles.Fonts.f2 * 0.8}
          light
          style={[styles.recentOrderIcon, recentOrderButtonStyle().marginStyle]}
        />
      )}
      <View>
        <Text
          nativeID={`Recent_Order_${Localized.Buttons.recent_orders}`}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
          style={[
            recentOrderButtonStyle().recentOrderText,
            recentOrderButtonStyle().marginStyle,
          ]}
        >
          {Localized.Buttons.recent_orders}
        </Text>
        {!props.showIcon && (
          <View style={recentOrderButtonStyle().textUnderline} />
        )}
      </View>
    </Pressable>
  );
}
const styles = StyleSheet.create({
  recentOrderButton: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: Styles.Heights.touchTargetHeight2,
    maxWidth: Styles.Heights.splashIconHeight,
  },
  recentOrderIcon: {
    alignSelf: 'center',
  },
});
